

let _instance = null
class TableSessionRepository {
    /**
     *
     * @returns {TableSessionRepository}
     */
    static getInstance() {
        if (!_instance) {
            _instance = new TableSessionRepository()
        }
        return _instance
    }
    assignMembership(tableSessionId, membershipId) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url : `/merchant/api/table_sessions/${tableSessionId}/membership`,
                type: 'post',
                data: {
                    membership_id: membershipId || '',
                },
                success: res => {
                    resolve()
                }
            })
            .fail(reject)
        })
    }
    applyFreeItem = (tableSessionId, membershipFreeItemId, orderId) => {
        return new Promise((resolve, reject) => {
            $.ajax({
                url : `/merchant/api/table_sessions/${tableSessionId}/free_item`,
                type: 'post',
                data: {
                    membership_free_item_id: membershipFreeItemId || '',
                    order_id: orderId || '',
                },
                success: res => {
                    resolve()
                }
            })
            .fail(reject)
        })
    }
}

export default TableSessionRepository
